var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 5.33333 5.33333",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4V1.28333L1.46667 2.15L1 1.66667L2.66667 0L4.33333 1.66667L3.86667 2.15L3 1.28333V4H2.33333ZM0.666667 5.33333C0.483333 5.33333 0.326389 5.26806 0.195833 5.1375C0.0652778 5.00694 0 4.85 0 4.66667V3.66667H0.666667V4.66667H4.66667V3.66667H5.33333V4.66667C5.33333 4.85 5.26806 5.00694 5.1375 5.1375C5.00694 5.26806 4.85 5.33333 4.66667 5.33333H0.666667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fc39b53936953e6365e5ef5adecebe16.svg";
export { ForwardRef as ReactComponent };